<template>
  <div
    ref="floatButton"
    class="float_button"
    @click="toContact"
    :style="{
      width: itemWidth + 'px',
      height: itemHeight + 'px',
      left: left + 'px',
      top: top + 'px',
    }"
    draggable
  >
    <img src="../assets/img/下载.svg" :draggable="false" />
  </div>
</template>

<script>
export default {
  props: {
    itemWidth: {
      type: Number,
      default: 50,
    },
    itemHeight: {
      type: Number,
      default: 50,
    },
    gapWidth: {
      type: Number,
      default: 20,
    },
    coefficientHeight: {
      type: Number,
      default: 0.76,
    },
  },
  data() {
    return {
      isPc: false,
      top: 0,
      left: 0,
      currentTop: 0,
      clientWidth: 0,
      clientHeight: 0,
      // 保存事件监听器引用，以便在beforeDestroy中移除
      eventListeners: {},
      // 节流控制变量
      isThrottlingTouch: false,
    };
  },
  created() {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      this.isPc = false;
    } else {
      this.isPc = true;
    }
    this.clientWidth = document.documentElement.clientWidth;
    this.clientHeight = document.documentElement.clientHeight;
    this.left = this.clientWidth - this.itemWidth - this.gapWidth;
    this.top = this.clientHeight * this.coefficientHeight;
  },
  mounted() {
    if (!this.isPc) {
      this.appInit();
    } else {
      this.pcInit();
    }
    // 保存resize事件引用
    this.eventListeners.resize = () => {
      this.clientWidth = document.documentElement.clientWidth;
      this.clientHeight = document.documentElement.clientHeight;
      this.left = this.clientWidth - this.itemWidth - this.gapWidth;
      this.top = this.clientHeight * this.coefficientHeight;
    };
    window.addEventListener('resize', this.eventListeners.resize);
  },
  // 添加beforeDestroy钩子，移除所有事件监听器
  beforeDestroy() {
    const floatButton = this.$refs.floatButton;
    if (floatButton) {
      // 移除所有事件监听器
      Object.keys(this.eventListeners).forEach(key => {
        if (key === 'resize') {
          window.removeEventListener('resize', this.eventListeners[key]);
        } else if (key === 'documentMousemove' || key === 'documentMouseup') {
          document.removeEventListener(key.replace('document', ''), this.eventListeners[key]);
        } else {
          floatButton.removeEventListener(key, this.eventListeners[key]);
        }
      });
    }
  },
  methods: {
    toContact() {},
    appInit() {
      this.$nextTick(() => {
        const floatButton = this.$refs.floatButton;
        
        // 保存事件监听器引用
        this.eventListeners.touchstart = () => {
          floatButton.style.transition = "none";
        };
        
        this.eventListeners.touchmove = (e) => {
          if (this.isThrottlingTouch) return;
          this.isThrottlingTouch = true;
          
          if (e.targetTouches.length === 1) {
            let touch = e.targetTouches[0];
            this.left = touch.clientX - 20;
            this.top = touch.clientY - 80;
            if (this.top < 0) {
              this.top = 0;
            } else if (this.top > this.clientHeight * this.coefficientHeight) {
              this.top = this.clientHeight * this.coefficientHeight;
            }
          }
          
          // 约60fps的节流控制
          setTimeout(() => {
            this.isThrottlingTouch = false;
          }, 16);
        };
        
        this.eventListeners.touchend = () => {
          floatButton.style.transition = "left 0.3s, top 0.3s";
          if (this.left > document.documentElement.clientWidth / 2) {
            this.left = this.clientWidth - this.itemWidth - this.gapWidth;
          } else {
            this.left = 10;
          }
        };
        
        // 添加事件监听器
        floatButton.addEventListener("touchstart", this.eventListeners.touchstart);
        floatButton.addEventListener("touchmove", this.eventListeners.touchmove);
        floatButton.addEventListener("touchend", this.eventListeners.touchend);
      });
    },
    pcInit() {
      this.$nextTick(() => {
        const floatButton = this.$refs.floatButton;
        let clientWidth = Number(this.clientWidth);
        let startX, startY;
        // 使用响应式数据管理位置
        let isDragging = false;
        // 节流控制
        let isThrottlingMouse = false;
        
        // 保存mousedown事件引用
        this.eventListeners.mousedown = (e) => {
          e.preventDefault();
          isDragging = true;
          startX = e.pageX - this.left;
          startY = e.pageY - this.top;
          // 保存document事件引用
          const onMouseMove = (event) => {
            event.preventDefault();
            if (!isThrottlingMouse && isDragging) {
              isThrottlingMouse = true;
              const newX = event.pageX - startX;
              const newY = event.pageY - startY;
              
              // 使用Vue响应式系统更新位置
              this.left = Math.max(0, Math.min(newX, clientWidth - this.itemWidth));
              this.top = Math.max(0, Math.min(newY, this.clientHeight - this.itemHeight));
              
              // 约60fps的节流控制
              setTimeout(() => {
                isThrottlingMouse = false;
              }, 16);
            }
          };
          
          const onMouseUp = () => {
            isDragging = false;
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseup", onMouseUp);
          };
          
          document.addEventListener("mousemove", onMouseMove);
          document.addEventListener("mouseup", onMouseUp);
          
          // 保存引用以便清理
          this.eventListeners.documentMousemove = onMouseMove;
          this.eventListeners.documentMouseup = onMouseUp;
        };
        
        floatButton.addEventListener(
          "mousedown",
          this.eventListeners.mousedown,
          false
        );
      });
    },
  },
};
</script>

<style lang="less" scoped>
.float_button {
  position: fixed;
  z-index: 999;
  cursor: pointer;
  // 使用props中的值，不硬编码宽度和高度
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  // 添加过渡效果，提升用户体验
  transition: left 0.3s, top 0.3s;
  // 提示浏览器提前优化
  will-change: left, top;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>